/*
 * Copyright (c) 2020.
 * ducnq
 */

import {
  SHORT_LINK_LIST_SUCCESS,
  SHORT_LINK_CREATE_SUCCESS,
  SHORT_LINK_EDIT_SUCCESS,
  SHORT_LINK_DETAIL_SUCCESS,
  SHORT_LINK_CREATE_ERROR,
  SHORT_LINK_EDIT_ERROR,
  SHORT_LINK_DETAIL_ERROR,
  SHORT_LINK_GET_ALL_SUCCESS,
} from "../ShortLinkConstants";

/**
 * @param {*} state
 * @param {*} action
 */
const ShortLinkReducer = (state = {}, action) => {
  if (action.payload === undefined || action.payload === false) return state;

  switch (action.type) {
    case SHORT_LINK_GET_ALL_SUCCESS:
    case SHORT_LINK_LIST_SUCCESS:
      let shortLinkList = action.payload.data.data;

      shortLinkList.map((shortLink) => {
        let id = shortLink["id"];
        state[id] = shortLink;
        return true;
      });

      return { ...state, action };

    case SHORT_LINK_CREATE_SUCCESS:
    case SHORT_LINK_EDIT_SUCCESS:
    case SHORT_LINK_DETAIL_SUCCESS:
    case SHORT_LINK_CREATE_ERROR:
    case SHORT_LINK_EDIT_ERROR:
    case SHORT_LINK_DETAIL_ERROR:
      let id = action.payload.data["id"];
      state[id] = action.payload.data;
      return { ...state, action };
    default:
      return state;
  }
};

export { ShortLinkReducer };
